import PropTypes from 'prop-types';

const ArrowSend = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="m19.067 8.308-6.25-6.25a.625.625 0 0 0-1.067.442v3.152c-2.027.173-4.265 1.166-6.106 2.727-2.217 1.882-3.598 4.306-3.888 6.826a.938.938 0 0 0 1.616.749c.86-.915 3.917-3.808 8.378-4.063V15a.624.624 0 0 0 1.067.441l6.25-6.25a.625.625 0 0 0 0-.883M13 13.491V11.25a.625.625 0 0 0-.625-.625c-2.194 0-4.33.572-6.35 1.703A15.3 15.3 0 0 0 3.166 14.4c.453-1.863 1.595-3.634 3.285-5.067 1.814-1.539 4.028-2.458 5.923-2.458A.625.625 0 0 0 13 6.25V4.01l4.741 4.74z"
            fill={color}
        />
    </svg>
);

export default ArrowSend;

ArrowSend.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
